import { FC } from 'react';

import { GridLayout, VSpacing } from '@hh.ru/magritte-ui';

import { AdminHeader } from 'components/Admin/AdminHeader/AdminHeader';
import { ModerationList } from 'components/Admin/ModerationList/ModerationList';
import Nav from 'components/Admin/Nav/Nav';

export const ModerationListPage: FC = () => (
    <>
        <AdminHeader />
        <GridLayout>
            <VSpacing default={24} />
            <Nav />
            <ModerationList />
        </GridLayout>
    </>
);
